import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

/**
 * Its own kind rather than the map's: picking a category in the drawer is a different emitter, and
 * the backend groups repeats by kind plus display text. The destination is in the text so browsing
 * restaurants in two stops stays two entries rather than one counted twice.
 */
export function buildThingsToDoCategorySelectedActivityEntry(
  categoryLabel: string,
  destinationName: string,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'things_to_do_category_selected',
    label: 'Browsed things to do',
    displayText: boundActivityDisplayText(`Browsed "${categoryLabel}" things to do in "${destinationName}"`),
    sourcePath: 'trip_planner.drawer.things_to_do_category',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
